import { queryOptions, useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'
import axios from 'axios'
import { QueryError } from 'errors'
import { Role } from 'types/auth'
import { UpdateUser, User } from 'types/users'

export const usersQuery = queryOptions<Array<User>>({
  queryKey: ['users'],
  queryFn: async () => (await axios.get('/users')).data,
  staleTime: 60_000,
})

export function useUsers() {
  return useSuspenseQuery(usersQuery)
}

export const rolesQuery = queryOptions<Array<Role>>({
  queryKey: ['roles'],
  queryFn: async () => (await axios.get('/users/roles')).data,
  staleTime: Infinity,
})

export function useRoles() {
  return useSuspenseQuery(rolesQuery)
}

export function useUpdateUser() {
  const queryClient = useQueryClient()

  return useMutation<User, QueryError, UpdateUser & { id: string }>({
    mutationKey: ['updateUser'],
    mutationFn: async (user) => {
      return (await axios.put(`/users/${user.id}`, user)).data
    },
    meta: {
      closeModal: true,
      successMessage: 'Dane użytkownika zostały zaktualizowane',
    },
    onSuccess: (updatedUser, { id }) => {
      queryClient.setQueryData<Array<User>>(['users'], (data) => {
        if (!data) return [updatedUser]
        return data.map((u) => (u.id === id ? updatedUser : u))
      })
    },
  })
}

export function useDeleteUser() {
  const queryClient = useQueryClient()

  return useMutation<void, QueryError, string>({
    mutationKey: ['deleteUser'],
    mutationFn: async (userId) => {
      await axios.delete(`/users/${userId}`)
    },
    meta: {
      closeModal: true,
      successMessage: 'Użytkownik został usunięty',
    },
    onSuccess: (_, userId) => {
      queryClient.setQueryData<Array<User>>(['users'], (data) => {
        if (!data) return []
        return data.filter((u) => u.id !== userId)
      })
    },
  })
}
